<template>
  
  <div class="single-credential layered" :class="{loading: loading}">

    <div class="header">
      <h3 class="mt-0">Credenziali di accesso</h3>
      <button @click="delete_credential = true" class="red-btn">rimuovi credenziali</button>
    </div>

    <v-switch :label="'Credenziale attiva'" :selected="data.attivo" v-model="status"/>

    <div class="info">
      <div class="block m-0">Username: <b>{{data.username}}</b></div>
      <div class="block m-0">Email associata: <b>{{data.email}}</b></div>
      <div class="block mt-2">
      
          <b-table :bordered="true" :striped="true" :data="credential.indirizzi">

            <b-table-column field="indirizzo_completo" label="Indirizzo" v-slot="props">
              <span class="is-size-7">{{props.row.indirizzo_completo}}</span>
            </b-table-column>
            <b-table-column label="" centered width="100" v-slot="props">
              <span class="delete" @click="disassociaIndirizzo(props.row.id)">x</span>
            </b-table-column>

          </b-table>
                
          <v-select :options="addresses"
            label="indirizzo_giustificato"
            :clearable="false"
            :searchable="false"
            v-model="nuovo_indirizzo"
            v-if="ctaAggiungiIndirizzo">
          </v-select>

          <b-button label="Aggiungi" @click="aggiungiIndirizzo()" :disabled="!nuovo_indirizzo" v-if="ctaAggiungiIndirizzo"></b-button>


          <b-button v-if="!ctaAggiungiIndirizzo" @click="ctaAggiungiIndirizzo = true" label="Aggiungi indirizzo"></b-button>
      
      </div>

    </div>

    <delete-credentials v-if="delete_credential" :credential="credential"/>

  </div>

</template>

<script>
import DeleteCredentials from './delete-credentials.vue';
export default{

  components: {DeleteCredentials},

  props: ['credential', 'addresses'],

  data: function(){

    return {
      data: this.credential,
      status: this.credential.attivo,
      loading: false,
      delete_credential: false,
      ctaAggiungiIndirizzo: false,
      nuovo_indirizzo: null
    }

  },

  computed: {

    address: function(){

      return this.data.num_progr_indirizzo ? this.data.indirizzo.rag_soc : null;

    },

    addressesAvailableToAdd(){

      // ....

    }

  },

  methods: {

    changeStatus: function(){

      var vue = this;
      vue.loading = true;

      axios({
        method: "post",
        url: window.location.origin + '/data/change-credentials-status',
        data: {
          id: vue.credential.id,
          status: vue.status ? 1 : 0
        } 
      })
      .then(res => {
        
        vue.$store.commit('add_message', {
          type: 'success',
          message: res.data.message
        });

      })
      .catch(err => {
        
        console.log(err.response.data);
        vue.$store.commit('add_message', {
          type: 'error',
          message: err.response.data.message
        });

      })
      .then(() =>{
        vue.loading = false;
      })

    },

    disassociaIndirizzo: function(id_indirizzo){

      /**
       * verifico che ci sia sempre almeno un indirizzo associato alla credenziale prima 
       * di richiedere la cancellazione
       */
      if( this.credential.indirizzi.length == 1 ){
        alert('Non è possibile eliminare l\'unico indirizzo associato alla credenziale');
        return;
      }

      var vue = this;
      vue.loading = true;

      axios({
        method: "post",
        url: window.location.origin + '/data/credentials/' + vue.credential.id + '/remove-address',
        data: {
          id_indirizzo: id_indirizzo
        } 
      })
      .then(res => {
        
        vue.$store.commit('add_message', {
          type: 'success',
          message: res.data.message
        });

        let index_to_remove = vue.credential.indirizzi.findIndex((element) => {
          return element.id == id_indirizzo
        }); 
        vue.credential.indirizzi.splice(index_to_remove, 1);

      })
      .catch(err => {
        
        console.log(err.response.data);
        vue.$store.commit('add_message', {
          type: 'error',
          message: err.response.data.message
        });

      })
      .then(() =>{
        vue.loading = false;
      })

    },

    aggiungiIndirizzo(){

      var vue = this;
      vue.loading = true;

      axios({
        method: "post",
        url: window.location.origin + '/data/credentials/' + vue.credential.id + '/add-address',
        data: {
          id_indirizzo: vue.nuovo_indirizzo.id
        } 
      })
      .then(res => {
        
        vue.$store.commit('add_message', {
          type: 'success',
          message: res.data.message
        });

        vue.ctaAggiungiIndirizzo = false;
        vue.credential.indirizzi.push( vue.nuovo_indirizzo )

      })
      .catch(err => {
        
        console.log(err.response.data);
        vue.$store.commit('add_message', {
          type: 'error',
          message: err.response.data.message
        });

      })
      .then(() =>{
        vue.loading = false;
      })

    }

  },

  watch: {

    status: function(){
      this.changeStatus();
    }

  },

  destroyed: function(){

    this.$parent.splitCredential(this.credential.id)
    this.$el.remove();

  }

}
</script>

<style scoped>
.single-credential{
  position: relative;
  padding: 1em 0;
  border-bottom: 1px solid gray;
}
.single-credential.loading::after{
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: gray;
  opacity: .3;
}
.header{
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
</style>
